import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import { LoaderService } from 'src/app/services/loader.service';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { take } from 'rxjs/operators';
import { ColumnasPefEnum } from 'src/app/shared/enums/columnas-pef-enum.enum';
import { AlertasService } from 'src/app/services/alertas.service';
import { UnidadResponsable } from 'src/app/models/entities/unidad-responsable';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { UsuarioEnSesionService } from 'src/app/services/usuario-en-sesion.service';
import { UsuarioSesionDTO } from 'src/app/models/dtos/usuario-sesion-dto';
import { PresupuestoEstado } from 'src/app/models/entities/presupuesto-estado';
import { LotePresupuestoEstado } from 'src/app/models/entities/lote-presupuesto-estado';
import { LotePresupuestoAcumulado } from 'src/app/models/entities/lote-presupuesto-acumulado';
import { PresupuestoAcumuladoMes } from 'src/app/models/entities/presupuesto-acumulado-mes';
import { PresupuestoAcumulado } from 'src/app/models/entities/presupuesto-acumulado';
import { LotePresupuestoService } from 'src/app/services/lote-presupuesto.service';
import { LotePresupuesto } from 'src/app/models/entities/lote-presupuesto';
import { LotePresupuestoHistoricoService } from 'src/app/services/lote-presupuesto-historico.service';

@Component({
  selector: 'carga-presupuestos',
  templateUrl: './carga-presupuestos.component.html',
  styleUrls: ['./carga-presupuestos.component.scss']
})
export class CargaPresupuestosComponent implements OnInit {


  @ViewChild('modalConfirmacion')
  public modal: any;
  public modalActivo: NgbModalRef;
  public archivos: File[] = [];
  public HOJA_BASE_GENERAL: number = 0;
  public HOJA_CAL_XP: number = 1;
  public catUnidadesResponsables: UnidadResponsable[] = [];
  public catDireccionesAdjuntas: ElementoCatalogo[] = [];
  public cargaPresupuestosForm: FormGroup;
  public anios: number[] = [];
  public meses: number[] = [];
  public nombresMeses: string[] = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];

  public programas: any = [
    {
      keyPrograma: "0",
      nombrePrograma: "CONSTRUCCIÓN Y MODERNIZACIÓN",
      inicioColumna: 2
    },
    {
      keyPrograma: "1",
      nombrePrograma: "CONSERVACIÓN Y RECONSTRUCCIÓN",
      inicioColumna: 5
    },
    {
      keyPrograma: "2",
      nombrePrograma: "ESTUDIOS Y PROYECTOS",
      inicioColumna: 8
    },
    {
      keyPrograma: "3",
      nombrePrograma: "CAMINOS RURALES Y ALIMENTADORES",
      inicioColumna: 12
    }
  ];

  public usuarioEnSesion: UsuarioSesionDTO = null;
  public lotePresupuestoEstado: LotePresupuestoEstado;
  public lotePresupuestoAcumulado: LotePresupuestoAcumulado;

  constructor(
    private ngbModalService: NgbModal,
    private loaderService: LoaderService,
    private catalogoService: CatalogoService,
    private alertasService: AlertasService,
    private lotePresupuestoService: LotePresupuestoService,
    private lotePresupuestoHistoricoService: LotePresupuestoHistoricoService,
    private formBuilder: FormBuilder,
    private usuarioEnSesionService: UsuarioEnSesionService
  ) { }

  private inicializarForm(): void {
    this.cargaPresupuestosForm = this.formBuilder.group({
      keyCatDireccionAdjunta: new FormControl("-1", [Validators.required, this.validarId]),
      anioPef: new FormControl('-1', [Validators.required, this.validarId]),
      metaAnioPef: new FormControl('-1', [Validators.required, this.validarId]),
      inicioMes: new FormControl('-1', [Validators.required, this.validarId]),
      finMes: new FormControl('-1', [Validators.required, this.validarId]),
      comentarios: new FormControl("", [Validators.required])
    });
  }

  async ngOnInit() {
    this.usuarioEnSesion = await this.usuarioEnSesionService.obtenerUsuario().pipe(take(1)).toPromise();
    this.catUnidadesResponsables = await this.catalogoService.obtenerCatalogo<UnidadResponsable>(RutaCatalogoEnum.UNIDADES_RESPONSABLES).pipe(take(1)).toPromise();
    this.catDireccionesAdjuntas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS).pipe(take(1)).toPromise();
    this.inicializarForm();
    this.cargarAnios();
    this.cargarMeses();
  }

  private validarId(control: AbstractControl) {
    return control.value === '-1' ? { error: 'El campo es requerido' } : null;
  }

  public obtenerMensajeValidacion(controlName: string): string {
    let error = '';
    let control = this.cargaPresupuestosForm.get(controlName);
    if ((control.touched && control.errors != null) || (control.touched && control.value === '-1')) {
      error = 'El campo es requerido';
    }
    return error;
  }

  public agregarArchivosParaCargar(archivos: FileList): void {
    this.inicializarLotes()
    this.archivos[0] = archivos[0];
  }

  public eliminarArchivoParaCargar(indice: number): void {
    this.archivos.splice(indice, 1);
    this.inicializarLotes()
  }

  public inicializarLotes(): void {
    this.lotePresupuestoEstado = null;
    this.lotePresupuestoAcumulado = null;
  }

  public abrirModalConfirmacion(): void {
    this.modalActivo = this.ngbModalService.open(this.modal, { centered: true, windowClass: 'modal-eliminacion' });
  }

  async descargarFormato() {
    const a = document.createElement("a");
    a.href = await this.toDataURL("../../../../../assets/carga-masiva/EE PEF 2020 - 2020.0210.1000.xlsx");
    a.download = "formato.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public toDataURL(url) {
    return fetch(url).then((response) => {
      return response.blob();
    }).then(blob => {
      return URL.createObjectURL(blob);
    });
  }

  public cargarArchivo() {
    let reader = new FileReader();
    reader.onload = (e: any) => {
      let datos = new Uint8Array(e.target.result);
      let libroTrabajo: XLSX.WorkBook = XLSX.read(datos, { type: "array" });
      let hojaBaseGeneral: XLSX.WorkSheet = libroTrabajo.Sheets[libroTrabajo.SheetNames[this.HOJA_BASE_GENERAL]];
      let hojaCalXp: XLSX.WorkSheet = libroTrabajo.Sheets[libroTrabajo.SheetNames[this.HOJA_CAL_XP]];
      this.crearLotePresupuestoEstado(hojaBaseGeneral);
      this.crearLotePresupuestoAcumulado(hojaCalXp);
    };
    reader.readAsArrayBuffer(this.archivos[0]);
  }


  public async guardarLotes(): Promise<any> {
    try {
      this.loaderService.activarLoaderScreen();
      let fechaActual: number = new Date().getTime();
      let lotePresupuesto: LotePresupuesto = {
        anio: parseInt(this.cargaPresupuestosForm.get('anioPef').value),
        fechaCreacion: fechaActual,
        fechaActualizacion: fechaActual,
        keyCatDireccionAdjunta: this.cargaPresupuestosForm.get('keyCatDireccionAdjunta').value,
        keyUsuarioCarga: this.usuarioEnSesion.usuario.key,
        lotePresupuestoAcumulado: this.lotePresupuestoAcumulado,
        lotePresupuestoEstado: this.lotePresupuestoEstado,
        comentarios: this.cargaPresupuestosForm.get('comentarios').value
      };
      await this.lotePresupuestoHistoricoService.save(lotePresupuesto);
      await this.lotePresupuestoService.save(lotePresupuesto);
      this.alertasService.mostrarAlerta("success", "Se ha cargado la información con éxito.");
    } catch (err) {
      console.error("Error al guardar lotes");
      this.alertasService.mostrarAlerta("error", "Ocurrió un error al cargar la información.", err);
    } finally {
      this.loaderService.desactivarLoaderScreen();
      this.modalActivo.close();
    }
    this.loaderService.desactivarLoaderScreen();
  }
  /**
   * Si estas cuatro columnas vienen vacías regresará un false, y por lo tanto, se saltará la fila.
   * @param hoja 
   * @param numeroFila 
   */
  private saltarFilaHojaBase(hoja: XLSX.WorkSheet, numeroFila: number): boolean {
    let ut: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.UT, r: numeroFila })];
    let k: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.K, r: numeroFila })];
    let noSolicitud: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.NO_SOLICITUD, r: numeroFila })];
    let registro: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.REGISTRO, r: numeroFila })];
    return (ut && k && noSolicitud && registro) ? true : false;
  }

  /**
   * 
   * @param hoja 
   * @param numeroFila 
   */
  public validarCamposRequeridosHojaBase(hoja: XLSX.WorkSheet, numeroFila: number): boolean {
    let edo: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.EDO, r: numeroFila })];
    let ur: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.UR, r: numeroFila })];
    let ut: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.UT, r: numeroFila })];
    let k: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.K, r: numeroFila })];
    let noSolicitud: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.NO_SOLICITUD, r: numeroFila })];
    let registro: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.REGISTRO, r: numeroFila })];
    let obra: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.NOMBRE_OBRA, r: numeroFila })];
    if (!edo) {
      this.alertasService.mostrarAlerta('error', `El valor en la celda ${XLSX.utils.encode_cell({ c: ColumnasPefEnum.EDO, r: numeroFila })} es requerido.`, null, 10000);
      return false;
    }
    if (!ur) {
      this.alertasService.mostrarAlerta('error', `El valor en la celda ${XLSX.utils.encode_cell({ c: ColumnasPefEnum.UR, r: numeroFila })} es requerido.`, null, 10000);
      return false;
    }
    if (!ut) {
      this.alertasService.mostrarAlerta('error', `El valor en la celda ${XLSX.utils.encode_cell({ c: ColumnasPefEnum.UT, r: numeroFila })} es requerido.`, null, 10000);
      return false;
    }
    if (!k) {
      this.alertasService.mostrarAlerta('error', `El valor en la celda ${XLSX.utils.encode_cell({ c: ColumnasPefEnum.K, r: numeroFila })} es requerido.`, null, 10000);
      return false;
    }
    if (!noSolicitud) {
      this.alertasService.mostrarAlerta('error', `El valor en la celda ${XLSX.utils.encode_cell({ c: ColumnasPefEnum.NO_SOLICITUD, r: numeroFila })} es requerido.`, null, 10000);
      return false;
    }
    if (!registro) {
      this.alertasService.mostrarAlerta('error', `El valor en la celda ${XLSX.utils.encode_cell({ c: ColumnasPefEnum.REGISTRO, r: numeroFila })} es requerido.`, null, 10000);
      return false;
    }
    if (!obra) {
      this.alertasService.mostrarAlerta('error', `El valor en la celda ${XLSX.utils.encode_cell({ c: ColumnasPefEnum.NOMBRE_OBRA, r: numeroFila })} es requerido.`, null, 10000);
      return false;
    }
    return true;
  }

  public validarDatosDeCatalogosHojaBase(hoja: XLSX.WorkSheet, numeroFila: number) {
    let ur: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.UR, r: numeroFila })];
    if (!ur) {
      this.alertasService.mostrarAlerta('error', `El valor en la celda ${XLSX.utils.encode_cell({ c: ColumnasPefEnum.UR, r: numeroFila })} es requerido.`, null, 10000);
      return false;
    }
    let valorEncontrado: UnidadResponsable = this.catUnidadesResponsables.find((unidadResponsable: UnidadResponsable) => unidadResponsable.cve.toString() === ur.v.toString().trim());
    if (!valorEncontrado) {
      this.alertasService.mostrarAlerta('error', `El valor en la celda ${XLSX.utils.encode_cell({ c: ColumnasPefEnum.UR, r: numeroFila })} no pertenece al catálogo de unidades responsables.`, null, 10000);
      return false;
    }
    return true;
  }

  public cargarAnios(): void {
    let fechaActual: Date = new Date();
    let contadorAnios: number = 0
    while (contadorAnios < 100) {
      this.anios.push(fechaActual.getFullYear() - contadorAnios);
      contadorAnios++;
    }
  }

  public cargarMeses(): void {
    let contadorMeses: number = 0
    while (contadorMeses < 12) {
      this.meses.push(contadorMeses);
      contadorMeses++;
    }
  }

  public crearLotePresupuestoAcumulado(hoja: XLSX.WorkSheet) {
    let presupuestosAcumulados: PresupuestoAcumulado[] = [];
    this.programas.forEach((programa: any) => {
      let presupuestosAcumuladosMeses: PresupuestoAcumuladoMes[] = [];
      for (let numeroFila = 10, indiceMes = 0; numeroFila <= 21; ++numeroFila, ++indiceMes) {
        let modificado: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: programa.inicioColumna, r: numeroFila })];
        let totalEjercido: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: programa.inicioColumna + 1, r: numeroFila })];
        let saldo: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: programa.inicioColumna + 2, r: numeroFila })];
        let presupuestoAcumuladoMes: PresupuestoAcumuladoMes = {
          mes: indiceMes,
          modificado: modificado ? modificado.v as number : 0,
          totalEjercido: totalEjercido ? totalEjercido.v as number : 0,
          saldo: saldo ? saldo.v as number : 0
        };
        presupuestosAcumuladosMeses.push(presupuestoAcumuladoMes);
      }
      let presupuestoAcumulado: PresupuestoAcumulado = {
        presupuestosAcumuladosMeses,
        keyPrograma: programa.keyPrograma,
        nombrePrograma: programa.nombrePrograma
      };
      presupuestosAcumulados.push(presupuestoAcumulado);
    });
    this.lotePresupuestoAcumulado = {
      anio: parseInt(this.cargaPresupuestosForm.get('anioPef').value),
      presupuestosAcumulados
    };
  }

  public crearLotePresupuestoEstado(hoja: XLSX.WorkSheet) {
    let datosCorrectos: boolean = true;
    let rango: XLSX.Range = XLSX.utils.decode_range(hoja['!ref']);
    let presupuestosEstados: Array<PresupuestoEstado> = new Array<PresupuestoEstado>();
    for (let numeroFila = 11; numeroFila <= rango.e.r; ++numeroFila) {
      if (!this.saltarFilaHojaBase(hoja, numeroFila)) {
        continue;
      }
      if (!this.validarCamposRequeridosHojaBase(hoja, numeroFila)) {
        datosCorrectos = false;
        break;
      }
      if (!this.validarDatosDeCatalogosHojaBase(hoja, numeroFila)) {
        datosCorrectos = false;
        break;
      }
      let edo: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.EDO, r: numeroFila })];
      let ur: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.UR, r: numeroFila })];
      let ut: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.UT, r: numeroFila })];
      let k: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.K, r: numeroFila })];
      let noSolicitud: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.NO_SOLICITUD, r: numeroFila })];
      let registro: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.REGISTRO, r: numeroFila })];
      let nombreObra: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.NOMBRE_OBRA, r: numeroFila })];
      let presupuestoEtiquetadoDof: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.PRESUPUESTO_ETIQUITADO_EN_DOF, r: numeroFila })];
      let pef: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.PEF, r: numeroFila })];
      let metaPef: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.META_PEF, r: numeroFila })];
      let modificadoSia: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.MODIFICADO_SIA, r: numeroFila })];
      let contratadoEnSistema: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.CONTRATADO_EN_SISTEMA, r: numeroFila })];
      let calendario: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.CALENDARIO, r: numeroFila })];
      let ejercidoEnTramite: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.EJERCIDO_EN_TRAMITE, r: numeroFila })];
      let ejercidoSia: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.EJERCIDO_SIA, r: numeroFila })];
      let ejercidoSiaff: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.EJERCIDO_SIAFF, r: numeroFila })];
      let totalEjercido: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.TOTAL_EJERCIDO, r: numeroFila })];
      let calendarioVsTotalEjercido: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.CALENDARIO_VS_TOTAL_EJERCIDO, r: numeroFila })];
      let observaciones: XLSX.CellObject = hoja[XLSX.utils.encode_cell({ c: ColumnasPefEnum.OBSERVACIONES, r: numeroFila })];
      let presupuesto: PresupuestoEstado = {
        edo: edo ? edo.v.toString().trim() : '',
        ur: ur ? ur.v.toString().trim() : '',
        ut: ut ? ut.v.toString().trim() : '',
        k: k ? k.v.toString().trim() : '',
        noSolicitud: noSolicitud ? noSolicitud.v.toString().trim() : '',
        registro: registro ? registro.v.toString().trim() : '',
        nombreObra: nombreObra ? nombreObra.v.toString().trim() : '',
        presupuestoEtiquetadoDof: presupuestoEtiquetadoDof ? presupuestoEtiquetadoDof.v as number : 0,
        pef: pef ? pef.v as number : 0,
        metaPef: metaPef ? metaPef.v as number : 0,
        modificadoSia: modificadoSia ? modificadoSia.v as number : 0,
        contratadoEnSistema: contratadoEnSistema ? contratadoEnSistema.v as number : 0,
        calendario: calendario ? calendario.v as number : 0,
        ejercidoEnTramite: ejercidoEnTramite ? ejercidoEnTramite.v as number : 0,
        ejercidoSia: ejercidoSia ? ejercidoSia.v as number : 0,
        ejercidoSiaff: ejercidoSiaff ? ejercidoSiaff.v as number : 0,
        totalEjercido: totalEjercido ? totalEjercido.v as number : 0,
        calendarioVsTotalEjercido: calendarioVsTotalEjercido ? calendarioVsTotalEjercido.v as number : 0,
        observaciones: observaciones ? observaciones.v.toString().trim() : '',
      };
      presupuestosEstados.push(presupuesto);
    }
    if (datosCorrectos) {
      this.lotePresupuestoEstado = {
        anioPef: parseInt(this.cargaPresupuestosForm.get('anioPef').value),
        metaAnioPef: parseInt(this.cargaPresupuestosForm.get('metaAnioPef').value),
        inicioMes: parseInt(this.cargaPresupuestosForm.get('inicioMes').value),
        finMes: parseInt(this.cargaPresupuestosForm.get('finMes').value),
        presupuestosEstados
      };
    } else {
      this.lotePresupuestoEstado = null;
    }
  }

}
